import {
  ButtonIcon,
  Caption,
  css,
  EllipsisText,
  InfoIcon,
  Inline,
  Paragraph,
  Stack,
  styled,
  TrashIcon,
} from 'canoe';
import React from 'react';

import { ContentPlacement } from '@candu-ai/placement/types';

export const LegacyUrlsWrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spaces.s};
    background-color: ${theme.colors.GlitterGrayL20};
    margin-bottom: ${theme.spaces.normal};
  `}
`;

const LegacyUrlRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: ${theme.spaces.xs};
  `}
`;

export const LegacyText = styled(Paragraph)<{ isLink?: boolean }>`
  ${({ theme, isLink }) => css`
    color: ${theme.colors.OnyxGrayL10};
    font-size: 14px;
    margin-bottom: 0;
    max-width: none;

    ${isLink &&
    css`
      min-width: 0;
      color: ${theme.colors.BrandPurple};
      cursor: not-allowed;
    `}
  `}
`;

interface Props {
  placement: ContentPlacement;
  deleteDenyURL: (index: number) => void;
}

export const LegacyUrls = ({ placement, deleteDenyURL }: Props) => {
  if (!placement.denyURLs || placement.denyURLs.length === 0) {
    return null;
  }

  return (
    <LegacyUrlsWrapper>
      <Stack space="xs">
        <Paragraph size="short" color="OnyxGrayL10" mb="none">
          <strong>Legacy URL rules</strong>
        </Paragraph>
        <Inline space="none" wrap="nowrap">
          <InfoIcon color="OnyxGrayL30" />
          <Caption color="OnyxGrayL10" mb="none" ml="xxs" maxWidth={680}>
            Some of your previous URL rules could not be converted into the new format. They are
            still valid but can no longer be edited. You can delete the legacy rules below and
            recreate them using the controls above.
          </Caption>
        </Inline>
        <Stack space="xxs">
          <LegacyText size="short">Do not show on the following URLs: </LegacyText>
          {placement.denyURLs.map((url, index) => (
            <LegacyUrlRow key={url}>
              <LegacyText isLink size="short">
                <EllipsisText content={url}>
                  <div>{url}</div>
                </EllipsisText>
              </LegacyText>
              <ButtonIcon
                icon={TrashIcon}
                size="small"
                color="contrast"
                onClick={() => deleteDenyURL(index)}
              />
            </LegacyUrlRow>
          ))}
        </Stack>
      </Stack>
    </LegacyUrlsWrapper>
  );
};
